import { styled, Box } from "@mui/material";

export const FrequentlyAskedSectionBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isEmpty",
})<{ $isEditMode?: boolean }>(({ theme, $isEditMode }) => ({
  display: "flex",
  flexDirection: "column",
  gap: $isEditMode ? theme.spacing(3) : theme.spacing(0),
}));
